import React from 'react';
import "./Loader.css"
import { useSelector } from 'react-redux';

export default function LoaderMailChimp() {
  // const and values
 const showLoaderMailChimp = useSelector((state) => state.showLoaderMailChimp?.showLoaderMailChimp);
 
  return (
    <div className={`${showLoaderMailChimp ? 'central-modal-overlay22' : ''}`}>
    <div className={`loader-container22 ${showLoaderMailChimp ? 'show22' : ''}`}>
    <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
        </div>
        </div>
  );
}